import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// 402 = subscription required. We dispatch a window event so the AuthContext
// can refresh the subscription state and the banner/toast can react globally
// without every caller having to handle this case.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const d = err.response.data?.detail;
      const code = (d && typeof d === "object" && d.code) || null;
      if (code === "subscription_required") {
        window.dispatchEvent(new CustomEvent("subscription:required", { detail: d }));
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function getGps({ required = true } = {}) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      if (required) return reject(new Error("Your device does not support location services. GPS is required to clock in."));
      return resolve(null);
    }
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
          device_info: navigator.userAgent,
        }),
      (err) => {
        if (required) {
          const msg =
            err && err.code === 1
              ? "Location permission denied. Enable GPS in your browser settings to clock in."
              : "Could not get your location. Move outdoors or check GPS and try again.";
          return reject(new Error(msg));
        }
        resolve({ lat: null, lng: null, device_info: navigator.userAgent });
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  });
}

export function fmtMoney(n) {
  const v = Number(n || 0);
  return `$${v.toFixed(2)}`;
}

export function fmtTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d + (d.length === 10 ? "T00:00:00" : "")).toLocaleDateString([], {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return d;
  }
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
